import DataDriven from "@modules/common/icons/data-driven";
import PillBubble from "./PillBubble";
import Profitable from "@modules/common/icons/profitable";
import Clock from "@modules/common/icons/clock";
import Gear from "@modules/common/icons/gear";
import GearStar from "@modules/common/icons/gear-star";
import { useTranslation } from "@i18n";

function Statement({
  data,
}: {
  data: {
    statementProfitableText: string;
    statementDataDriventext: string;
    statementPerfectMomentText: string;
    statementWithoutManualWorkText: string;
    statementSpotlighText: string;
  };
}) {
  const { t } = useTranslation();
  void data;
  return (
    <div className="w-full px-4 sm:px-24 sm:text-4xl !leading-loose text-darkGreen text-center tracking-wider">
      {t.statement.empowerPrefix}
      <PillBubble
        text={t.statement.profitable}
        description={t.statement.descriptions.profitable}
        Icon={Profitable}
      />
      {t.statement.personalizedComma}
      <PillBubble
        text={t.statement.dataDriven}
        description={t.statement.descriptions.dataDriven}
        Icon={DataDriven}
      />
      {t.statement.middle}
      <PillBubble
        text={t.statement.perfectMoment}
        description={t.statement.descriptions.perfectMoment}
        Icon={Clock}
      />
      {t.statement.dash}
      <PillBubble
        text={t.statement.withoutManual}
        description={t.statement.descriptions.withoutManual}
        Icon={Gear}
      />
      {t.statement.end}
      <PillBubble
        text={t.statement.spotlight}
        description={t.statement.descriptions.spotlight}
        Icon={GearStar}
      />
      {t.statement.finalDot}
    </div>
  );
}

export default Statement;
